<template>
  <div :id="'items-table' + tripNumber" class="items-table">
    <div class="items-table__mobile">
      <b-form-group
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0 d-none d-sm-block d-md-none d-block d-sm-none"
      >
        <div class="items-table__mobile__buttons row">
          <div class="items-table__mobile__buttons__table col">
            <b-overlay
              :show="deletingCommodity"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
              @hidden="onHidden('delete-commodity-button')"
            >
              <b-button
                ref="delete-commodity-button"
                :disabled="deletingCommodity"
                v-if="allowed"
                class="items-table__mobile__buttons__table--delete"
                size="sm"
                @click="deleteRows"
                >Delete</b-button
              >
            </b-overlay>
            <b-overlay
              :show="addingCommodity"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
              @hidden="onHidden('add-commodity-button')"
            >
              <b-button
                ref="add-commodity-button"
                :disabled="addingCommodity"
                v-if="allowed"
                class="items-table__mobile__buttons__table--add-row"
                size="sm"
                @click="addItem()"
                >Add new row</b-button
              >
            </b-overlay>
          </div>
        </div>
      </b-form-group>
    </div>
    <b-table
      show-empty
      hover
      small
      foot-clone
      class="items-table__table"
      head-variant="light"
      stacked="md"
      fixed
      :items="items"
      :busy="isBusy"
      :fields="fields"
    >
      <template v-slot:thead-top="data">
        <b-tr v-bind:key="data.columns">
          <b-th variant="dark" :colspan="fields.length">
            <h4 v-if="!allowed" class="text-left"><b>Details</b></h4>
            <div class="row">
              <div class="items-table__table__buttons-table">
                <div>
                  <b-overlay
                    :show="deletingCommodity"
                    rounded
                    opacity="0.6"
                    spinner-small
                    class="d-inline-block"
                    @hidden="onHidden('delete-commodity-button')"
                  >
                    <b-button
                      ref="delete-commodity-button"
                      :disabled="deletingCommodity"
                      v-if="allowed"
                      class="items-table__table__buttons-table--delete"
                      size="sm"
                      @click="deleteRows"
                      >Delete</b-button
                    >
                  </b-overlay>
                  <b-overlay
                    :show="addingCommodity"
                    rounded
                    opacity="0.6"
                    spinner-small
                    class="d-inline-block"
                    @hidden="onHidden('add-commodity-button')"
                  >
                    <b-button
                      ref="add-commodity-button"
                      :disabled="addingCommodity"
                      v-if="allowed"
                      @click="addItem()"
                      class="items-table__table__buttons-table--add-row"
                      size="sm"
                      >Add new row</b-button
                    >
                  </b-overlay>
                </div>
                <div
                  class="items-table__table__select-container ml-5"
                  size="sm"
                >
                  <label class="mr-2">Equipment Type: </label>
                  <el-select
                    :key="keyRender"
                    v-model="selectedEquipment"
                    placeholder="Select a equipment type"
                    size="small"
                    @change="updateEquipmentType()"
                  >
                    <el-option
                      v-for="equipment in equipmentTypes"
                      :key="equipment.value"
                      :label="equipment.label"
                      :value="equipment"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </b-th>
        </b-tr>
      </template>

      <template v-slot:head(actions)="column">
        <b-form-checkbox
          :id="column.index"
          v-model="areAllSelected"
          name="checkbox-1"
          value="accepted"
          unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template v-slot:head(hu_count)="row">
        <span :key="row.label" class="items-table__table__header">{{
          fields[1].label
        }}</span>
      </template>

      <template v-slot:head(dimensions)="row">
        <span :key="row.label" class="items-table__table__header">{{
          fields[2].label
        }}</span>
      </template>

      <template v-slot:head(weight)="row">
        <span :key="row.label" class="items-table__table__header">{{
          fields[3].label
        }}</span>
      </template>

      <template v-slot:head(commodity)="row">
        <span :key="row.label" class="items-table__table__header">{{
          fields[4].label
        }}</span>
      </template>

      <template v-slot:cell(actions)="row">
        <b-form-checkbox
          v-model="items[row.index].isChecked"
          name="select-row"
          value="accepted"
          unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template v-slot:cell(hu_count)="row">
        <b-form-input
          :ref="`huCountInput${row.index}`"
          class="items-table__table--input"
          v-model="items[row.index].hu_count"
          @keyup.enter="$refs[`huCountInput${row.index}`].blur()"
          @blur="updateCommodity(row.index, 'hu_count')"
          size="sm"
          list="hu_count"
          autocomplete="off"
        ></b-form-input>

        <datalist id="hu_count">
          <option v-for="(hc, index) in hu_count" v-bind:key="index">{{
            hc
          }}</option>
        </datalist>
      </template>

      <template v-slot:cell(dimensions)="row">
        <b-form-input
          :ref="`dimensionsInput${row.index}`"
          class="items-table__table--input"
          v-model="items[row.index].dimensions"
          @keyup.enter="$refs[`dimensionsInput${row.index}`].blur()"
          @blur="updateCommodity(row.index, 'dimensions')"
          size="sm"
          list="dimensions"
          autocomplete="off"
        ></b-form-input>

        <datalist id="dimensions">
          <option v-for="(dim, index) in dimensions" v-bind:key="index">{{
            dim
          }}</option>
        </datalist>
      </template>

      <template v-slot:cell(weight)="row">
        <b-form-input
          :ref="`weightInput${row.index}`"
          class="items-table__table--input"
          v-model="items[row.index].weight"
          @keyup.enter="$refs[`weightInput${row.index}`].blur()"
          @blur="updateCommodity(row.index, 'weight')"
          size="sm"
          list="weight"
          autocomplete="off"
        ></b-form-input>

        <datalist id="weight">
          <option v-for="(w, index) in weight" v-bind:key="index">{{
            w
          }}</option>
        </datalist>
      </template>

      <template v-slot:cell(commodity)="row">
        <b-form-input
          :ref="`commodityInput${row.index}`"
          class="items-table__table--input"
          v-model="items[row.index].commodity"
          @keyup.enter="$refs[`commodityInput${row.index}`].blur()"
          @blur="updateCommodity(row.index, 'commodity')"
          size="sm"
          list="commodity"
          autocomplete="off"
        ></b-form-input>

        <datalist id="commodity">
          <option v-for="(com, index) in commodity" v-bind:key="index">{{
            com
          }}</option>
        </datalist>
      </template>

      <template v-slot:foot(actions)="column">
        <b-form-input
          readonly
          class="items-table__table__footer--totals-title"
          :key="column.label"
          v-model="totalsTitle"
          size="sm"
          autocomplete="off"
        ></b-form-input>
      </template>

      <template v-slot:foot(hu_count)="column">
        <div class="items-table__table__footer__total-hu">
          <b-form-input
            readonly
            class="items-table__table__footer__total-hu--total"
            :key="column.label"
            v-model="totalHuCount"
            placeholder="Total hu count"
            size="sm"
            autocomplete="off"
          ></b-form-input>
          <b-form-input
            list="handling-units"
            v-model="handlingUnitSelected"
            class="items-table__table__footer__total-hu--units"
            placeholder="Units"
            autocomplete="off"
          ></b-form-input>

          <datalist id="handling-units">
            <option v-for="unit in handlingUnits" v-bind:key="unit">{{
              unit
            }}</option>
          </datalist>
        </div>
      </template>

      <template v-slot:foot(dimensions)="column">
        <b-form-input
          readonly
          class="items-table__table__footer--total-volume"
          :key="column.label"
          v-model="volumeAndDensity.volume"
          placeholder="Total volume"
          size="sm"
          autocomplete="off"
        ></b-form-input>
      </template>

      <template v-slot:foot(weight)="column">
        <b-form-input
          ref="totalWeightInput"
          :key="column.label"
          v-model="totalWeight"
          @keyup.enter="$refs.totalWeightInput.blur()"
          @blur="standardizeTotalWieght"
          class="items-table__table__footer--total-weight"
          placeholder="Total weight"
          size="sm"
          autocomplete="off"
        ></b-form-input>
      </template>

      <template v-slot:foot(commodity)="column">
        <b-input-group>
          <b-form-input
            disabled
            ref="linearFeetInput"
            v-model="haulInformation[tripNumber - 1].linear_feet"
            title="Linear Feet"
            onClick="this.select();"
            @keyup.enter="$refs.linearFeetInput.blur()"
            @blur="updateHaul"
            :key="column.label"
            type="number"
            class="items-table__table__footer--linear-feet"
            placeholder="Linear feet"
            size="sm"
            autocomplete="off"
          ></b-form-input>
          <b-input-group-append>
            <b-overlay
              :show="addingLinearFeet"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
            >
              <b-button
                :disabled="disableCalculate"
                @click="calculateLinearFeet()"
                class="calculate-linear-feet"
                variant="info"
                ><i class="fa fa-calculator"></i
              ></b-button>
            </b-overlay>
          </b-input-group-append>
        </b-input-group>
      </template>

      <template v-slot:foot(expectedCost)="column">
        <b-form-input
          ref="expectedCostInput"
          v-model="haulInformation[tripNumber - 1].expected_cost"
          title="Expected Cost"
          onClick="this.select();"
          @keyup.enter="$refs.expectedCostInput.blur()"
          @blur="updateHaul"
          :key="column.label"
          type="number"
          class="items-table__table__footer--expected-cost"
          placeholder="Expected Cost"
          size="sm"
          autocomplete="off"
        ></b-form-input>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { equipmentMap } from "@/utils/OTR/equipmentTypes";
export default {
  name: "ItemsTableFTL",
  props: {
    tripNumber: Number,
    pickupAndDelivery: Array,
    accessorials: Array,
    // detailsTrip: Array,
    fullItems: Array,
    actualQueue: String
  },
  data() {
    return {
      items: [],
      fields: [
        { key: "actions", label: "Actions" },
        {
          key: "hu_count",
          label: "HU COUNT"
        },
        {
          key: "dimensions",
          label: "DIMENSIONS"
        },
        {
          key: "weight",
          label: "WEIGHT"
        },
        {
          key: "commodity",
          label: "COMMODITY"
        },
        {
          key: "expectedCost",
          label: ""
        }
      ],
      hu_count: [],
      dimensions: [],
      weight: [],
      commodity: [],
      handlingUnits: [
        "Bags",
        "Boxes",
        "Bundles",
        "Cartons",
        "Cases",
        "Coils",
        "Containers",
        "Crates",
        "Drums",
        "Packages",
        "Pallets",
        "Pieces",
        "Rolls",
        "Skids",
        "Truckload",
        "Tubes",
        "Units"
      ],
      handlingUnitSelected: null,
      areAllSelected: "not_accepted",
      haulInformation: null,
      totalHuCount: 0,
      totalWeight: 0,
      totalsTitle: "Totals:",
      totalHuCountAux: [],
      volumeAndDensity: {
        volume: 0,
        density: 0
      },
      allowed: true,
      addingCommodity: false,
      deletingCommodity: false,
      isBusy: false,
      updateTotals: 0,
      item: null,
      assignedUser: null,
      currentDepartment: null,
      selectedModeName: null,
      selectedEquipment: null,
      containerOptions: null,
      equipmentTypes: null,
      addingLinearFeet: false,
      disableCalculate: true,
      keyRender: 0
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes/quote", ["showSelectedMode"]),
    ...mapState({ expectedCost: state => state.quotes.xenon.expectedCost })
  },
  watch: {
    expectedCost: function() {
      this.haulInformation[
        this.tripNumber - 1
      ].expected_cost = this.expectedCost;
    },
    areAllSelected: function() {
      for (let item in this.items) {
        if (this.areAllSelected === "accepted") {
          this.items[item].isChecked = "accepted";
        } else if (this.areAllSelected === "not_accepted") {
          this.items[item].isChecked = "not_accepted";
        }
      }
    },
    items: function() {
      return this.$emit("input", this.items);
    },
    handlingUnitSelected: function() {
      let info = {};
      info.trip = this.tripNumber - 1;
      info.handlingUnit = this.handlingUnitSelected;
      this.$store.commit("setHandlingUnitsHuCount", info);
    },
    async showInfoDepartment(value) {
      this.currentDepartment = value;
    },
    showSelectedMode() {
      this.getEquipments();
      this.keyRender += 1;
    },
    selectedEquipment() {
      if (this.selectedEquipment) {
        this.disableCalculate = false;
      }
    }
  },
  async beforeMount() {
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    // if (
    //   this.$store.getters["quotes/quote/showQuoteById"].model_response.entities
    // ) {
    //   this.commodity = this.$store.getters[
    //     "quotes/quote/showQuoteById"
    //   ].model_response.entities.commodity;
    // }
    this.isBusy = true;
    let quoteId = this.$route.params.id;
    await this.$store.dispatch("quotes/quote/getQuote", quoteId);
    if (this.haulInformation[this.tripNumber - 1].commodity.length == 0) {
      this.createDefaultRow();
    } else {
      this.getItems();
      await this.getAllTotals();
    }
    for (let haul in this.haulInformation) {
      for (let i in this.haulInformation[haul].commodity) {
        if (
          !this.hu_count.includes(
            this.haulInformation[haul].commodity[i].hu_count
          )
        ) {
          this.hu_count.push(this.haulInformation[haul].commodity[i].hu_count);
        }
        if (
          !this.dimensions.includes(
            this.haulInformation[haul].commodity[i].dimensions
          )
        ) {
          this.dimensions.push(
            this.haulInformation[haul].commodity[i].dimensions
          );
        }
        if (
          this.haulInformation[haul] &&
          !this.weight.includes(this.haulInformation[haul].commodity[i].weight)
        ) {
          this.weight.push(this.haulInformation[haul].commodity[i].weight);
        }
      }
      this.isBusy = false;
      let info = {};
      info.trip = this.tripNumber - 1;
      info.handlingUnit = "";
      this.$store.commit("setHandlingUnitsHuCount", info);
    }
    this.getEquipments();
  },
  async mounted() {
    this.currentDepartment = this.showInfoDepartment;
    this.handlerItemsTableFTL();
    return this.$emit("input", this.items);
  },
  methods: {
    extractWeightNumber(weightString) {
      if (weightString == null || weightString == "") return 0;
      const number = parseFloat(weightString.replace(/[^\d.]/g, ""));
      return isNaN(number) ? 0 : number;
    },
    getItems() {
      this.haulInformation = this.$store.getters[
        "quotes/quote/showQuoteById"
      ].haul;
      if (this.haulInformation[this.tripNumber - 1]) {
        this.items = [];
        for (let item in this.haulInformation[this.tripNumber - 1].commodity) {
          let newItem = {};
          newItem.isChecked = "not_accepted";
          newItem.hu_count = this.haulInformation[
            this.tripNumber - 1
          ].commodity[item].hu_count;
          newItem.dimensions = this.haulInformation[
            this.tripNumber - 1
          ].commodity[item].dimensions;
          newItem.weight = this.haulInformation[this.tripNumber - 1].commodity[
            item
          ].weight;
          if (
            this.haulInformation[this.tripNumber - 1].commodity[item]
              .description
          ) {
            let charAtString = this.haulInformation[
              this.tripNumber - 1
            ].commodity[item].description.toLowerCase();
            newItem.commodity =
              charAtString.charAt(0).toUpperCase() + charAtString.slice(1);
          } else {
            newItem.commodity = null;
          }
          this.items.push(newItem);
        }
      }
    },
    async deleteRows() {
      this.deletingCommodity = true;
      for (let i in this.items) {
        if (this.items[i].isChecked == "accepted") {
          let commodityId = this.haulInformation[this.tripNumber - 1].commodity[
            i
          ].id;
          await this.$store.dispatch(
            "quotes/commodity/deleteCommodity",
            commodityId
          );
          this.items[i].isChecked == "not_accepted";
        }
      }
      if (this.areAllSelected == "accepted") {
        this.areAllSelected = "not_accepted";
      }
      let quoteId = this.$route.params.id;
      await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      this.items = [];
      this.getItems();
      this.deletingCommodity = false;
    },
    async addItem() {
      this.createRow("", "", "", "");
    },
    sendOversize(index) {
      console.info(index);
    },
    async addHuCount(row) {
      let response;
      if (this.items[row].hu_count != null && this.items[row].hu_count != "") {
        response = await this.$store.dispatch(
          "standardize/standardizeHuCount",
          this.items[row].hu_count
        );
        if (response.status == 200) {
          this.items[row].hu_count = response.data[0];
          if (!this.hu_count.includes(this.items[row].hu_count)) {
            this.hu_count.push(this.items[row].hu_count);
          }
          await this.getTotalHuCount();
          await this.getTotalWeight();
          await this.getCalculateVolumeAndDensity();
          this.updateTotals = 0;
          return response.data[0];
        }
      }
    },
    async addDimensions(row) {
      let response;
      if (
        this.items[row].dimensions != null &&
        this.items[row].dimensions != ""
      ) {
        response = await this.$store.dispatch(
          "standardize/standardizeDimensions",
          this.items[row].dimensions
        );
        if (response.status == 200) {
          this.items[row].dimensions = response.data[0];
          if (!this.dimensions.includes(this.items[row].dimensions)) {
            this.dimensions.push(this.items[row].dimensions);
          }
          await this.getCalculateVolumeAndDensity();
          this.updateHaul();
          this.updateTotals = 0;
          return response.data[0];
        }
      }
    },
    async addWeight(row) {
      let response;
      let calculatedWeight;
      if (this.items[row].weight != null && this.items[row].weight != "") {
        this.items[row].weight = this.items[row].weight.replaceAll(" ", "");
        let unitsAux = this.items[row].weight.replace(/[^a-z]/gi, "");
        this.items[row].weight = this.items[row].weight.replaceAll(
          unitsAux,
          ""
        );
        calculatedWeight = eval(this.items[row].weight) + unitsAux;
        response = await this.$store.dispatch(
          "standardize/standardizeWeight",
          calculatedWeight
        );
        if (response.status == 200) {
          this.items[row].weight = response.data[0];
          if (!this.weight.includes(this.items[row].weight)) {
            this.weight.push(this.items[row].weight);
          }
          await this.getTotalWeight();
          this.updateHaul();
          this.updateTotals = 0;
          return response.data[0];
        }
      }
    },
    addCommodity(row) {
      if (
        this.items[row.index].commodity != null &&
        this.items[row.index].commodity != "" &&
        !this.commodity.includes(this.items[row.index].commodity)
      ) {
        this.commodity.push(this.items[row.index].commodity);
      }
    },
    async getCalculateVolumeAndDensity() {
      let dimensionsAux = [];
      for (let item in this.items) {
        if (
          this.items[item].dimensions != null &&
          this.items[item].dimensions != ""
        ) {
          dimensionsAux.push(this.items[item].dimensions);
        }
      }
      if (
        this.totalHuCountAux.length === 0 ||
        dimensionsAux.length === 0 ||
        dimensionsAux.length !== this.totalHuCountAux.length
      ) {
        return;
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      info.dimensions = dimensionsAux;
      info.total_weight = this.extractWeightNumber(this.totalWeight);
      let response = await this.$store.dispatch(
        "totals/getCalculateVolumeAndDensity",
        info
      );
      if (response.status == 200) {
        this.volumeAndDensity = response.data;
      }
      if (
        this.$route.params.pathName === "myQueue" ||
        this.$route.params.pathName === "queue" ||
        this.$route.params.pathName === "failed" ||
        this.$route.params.pathName === "alerts"
      ) {
        this.updateTotals += 1;
        if (this.updateTotals == 3) {
          this.updateHaul();
        }
        this.updateTotals = 0;
      }
    },
    async getTotalHuCount() {
      this.totalHuCountAux = [];
      for (let item in this.items) {
        if (
          this.items[item].hu_count != null &&
          this.items[item].hu_count != ""
        ) {
          this.totalHuCountAux.push(this.items[item].hu_count);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      let response = await this.$store.dispatch("totals/getTotalHuCount", info);
      if (response.status == 200) {
        if (response.data.includes(" ")) {
          this.totalHuCount = response.data.split(" ")[0];
        } else {
          this.totalHuCount = response.data;
        }
      }
      if (
        this.$route.params.pathName === "myQueue" ||
        this.$route.params.pathName === "queue" ||
        this.$route.params.pathName === "failed" ||
        this.$route.params.pathName === "alerts"
      ) {
        this.updateTotals += 1;
      }
    },
    async getTotalWeight() {
      let totalWeightAux = [];
      for (let item in this.items) {
        if (this.items[item].weight != null && this.items[item].weight != "") {
          totalWeightAux.push(this.items[item].weight);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      info.weight = totalWeightAux;
      let response = await this.$store.dispatch("totals/getTotalWeight", info);
      if (response.status == 200) {
        this.totalWeight = response.data;
      }
      if (
        this.$route.params.pathName === "myQueue" ||
        this.$route.params.pathName === "queue" ||
        this.$route.params.pathName === "failed" ||
        this.$route.params.pathName === "alerts"
      ) {
        this.updateTotals += 1;
      }
    },
    async standardizeTotalWieght() {
      let response;
      if (this.totalWeight != null && this.totalWeight != "") {
        response = await this.$store.dispatch(
          "standardize/standardizeWeight",
          this.totalWeight
        );
        if (response.status == 200) {
          this.totalWeight = this.extractWeightNumber(response.data[0]);
          await this.updateHaul();
        }
      }
    },
    // async modifyQuote() {
    //   let info = {};
    //   info.accessorials = this.accessorials;
    //   info.detailsTrip = this.detailsTrip;
    //   info.items = [];
    //   for (let c = 0; c < this.fullItems.length; c++) {
    //     info.items[c] = this.fullItems[c];
    //   }
    //   info.pickupAndDelivery = this.pickupAndDelivery;
    //   await this.$store.dispatch("quotes/modifyQuote", info);
    //   this.haulInformation = this.$store.getters[
    //     "quotes/quote/showQuoteById"
    //   ].haul;
    // },
    onHidden(buttonName) {
      this.$refs[buttonName].focus();
    },
    async updateCommodity(i, type) {
      if (this.items[i][type]) {
        let info = {};
        info.commodityId = this.haulInformation[this.tripNumber - 1].commodity[
          i
        ].id;
        info.payload = {};
        if (type == "hu_count") {
          info.payload.hu_count = await this.addHuCount(i);
          this.haulInformation[this.tripNumber - 1].linear_feet = null;
        }
        if (type == "dimensions") {
          info.payload.dimensions = await this.addDimensions(i);
          this.haulInformation[this.tripNumber - 1].linear_feet = null;
        }
        if (type == "weight") {
          info.payload.weight = await this.addWeight(i);
          this.haulInformation[this.tripNumber - 1].linear_feet = null;
        }
        if (type === "commodity") {
          if (this.items[i].commodity) {
            this.items[i].commodity = this.items[i].commodity.toLowerCase();
            this.items[i].commodity =
              this.items[i].commodity.charAt(0).toUpperCase() +
              this.items[i].commodity.slice(1);
          } else {
            this.items[i].commodity = "";
          }
        }
        if (this.items[i].commodity) {
          info.payload.description = this.items[i].commodity;
        } else {
          info.payload.description = "";
        }
        await this.$store.dispatch("quotes/commodity/updateCommodity", info);
      }
    },
    updateHaul() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      if (
        this.haulInformation[this.tripNumber - 1].linear_feet != null &&
        this.haulInformation[this.tripNumber - 1].linear_feet != ""
      ) {
        info.payload.linear_feet = this.haulInformation[
          this.tripNumber - 1
        ].linear_feet;
      } else {
        info.payload.linear_feet = "";
      }
      if (
        this.haulInformation[this.tripNumber - 1].expected_cost != null &&
        this.haulInformation[this.tripNumber - 1].expected_cost != ""
      ) {
        info.payload.expected_cost = this.haulInformation[
          this.tripNumber - 1
        ].expected_cost;
      } else {
        info.payload.expected_cost = 0;
      }
      if (this.totalWeight != null && this.totalWeight != "") {
        info.payload.total_weight = this.totalWeight;
      } else {
        info.payload.total_weight = 0;
      }
      if (
        this.haulInformation[this.tripNumber - 1].equipment_type != null &&
        this.haulInformation[this.tripNumber - 1].equipment_type != ""
      ) {
        info.payload.equipment_type = this.selectedEquipment?.value;
      } else {
        info.payload.equipment_type = "";
      }
      info.payload.total_hu_count = this.totalHuCount;
      info.payload.cbf = String(this.volumeAndDensity.volume ?? "");
      this.$store.dispatch("quotes/haul/updateHaul", info);
      document.activeElement.blur();
    },
    async getAllTotals() {
      if (
        this.$route.params.pathName !== "sent" ||
        this.$route.params.pathName !== "inProcess"
      ) {
        await this.getTotalHuCount();
        await this.getTotalWeight();
        await this.getCalculateVolumeAndDensity();
      }
    },
    handlerItemsTableFTL() {
      let userAux = localStorage.getItem("charlie-username-otr");
      this.user = JSON.parse(userAux);
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      let allowedRoutes = ["queue", "myQueue", "failed"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (
        this.currentDepartment.rol_name == "superuser" ||
        !this.allowed ||
        this.user[0].user.username !== this.assignedUser
      ) {
        document.getElementById(
          `items-table` + this.tripNumber
        ).style.pointerEvents = "none";
      }
    },
    async createRow(huCount, dimensions, weight, description) {
      this.addingCommodity = true;
      let info = {};
      info.haul_ = this.haulInformation[this.tripNumber - 1].id;
      info.hu_count = huCount;
      info.dimensions = dimensions;
      info.weight = weight;
      info.description = description;
      let response = await this.$store.dispatch(
        "quotes/commodity/addCommodity",
        info
      );
      if (response.status == 200) {
        let quoteId = this.$route.params.id;
        await this.$store.dispatch("quotes/quote/getQuote", quoteId);
        await this.getItems();
        await this.getTotalHuCount();
        await this.getTotalWeight();
        await this.getCalculateVolumeAndDensity();
      }
      this.addingCommodity = false;
    },
    async createDefaultRow() {
      this.createRow(
        "1 Pallet",
        "48.0 x 40.0 x 84.0 inch",
        "500 lb",
        "General"
      );
    },
    async calculateLinearFeet() {
      this.addingLinearFeet = true;
      let info = {
        body: []
      };
      let currentAccessorials;
      let quoteId = this.$route.params.id;
      let fullQuote = await this.$store.dispatch(
        "quotes/quote/getQuote",
        quoteId
      );
      fullQuote.data.haul[this.tripNumber - 1].accessorial.forEach(element => {
        if (element.accessorial.name.toLowerCase() == "stackable") {
          currentAccessorials = element.accessorial.name.toLowerCase();
        }
      });
      for (let i = 0; i < this.items.length; i++) {
        let flagStackable = false;
        if (currentAccessorials === "stackable") {
          flagStackable = true;
        }
        info.body.push({
          dimensions:
            fullQuote.data.haul[this.tripNumber - 1].commodity[i].dimensions,
          hu_count:
            fullQuote.data.haul[this.tripNumber - 1].commodity[i].hu_count,
          weight: fullQuote.data.haul[this.tripNumber - 1].commodity[i].weight,
          stackable: flagStackable
        });
        info.container = this.selectedEquipment?.label;
      }
      let mode = this.$store.getters["quotes/quote/showQuoteById"].haul[0]
        .tms_mode.name;
      info.mode = mode;
      let calculateLinearFeet = await this.$store.dispatch(
        "totals/getCalculateLinearFeetFTL",
        info
      );
      if (calculateLinearFeet.status == 200) {
        this.haulInformation[this.tripNumber - 1].linear_feet =
          calculateLinearFeet.data.linear_feet;
        this.haulInformation[
          this.tripNumber - 1
        ].equipment_type = this.selectedEquipment?.value;
        this.updateHaul();
      } else {
        this.haulInformation[this.tripNumber - 1].linear_feet = null;
      }
      this.addingLinearFeet = false;
    },
    getEquipments() {
      this.selectedModeName = this.$store.getters[
        "quotes/quote/showSelectedMode"
      ];
      this.equipmentTypes = [];
      if (!this.selectedModeName) return;
      const mode = this.selectedModeName.toLowerCase();
      if (!equipmentMap[mode]) return;
      this.equipmentTypes = equipmentMap[mode];
      equipmentMap[mode].forEach(
        element =>
          (this.selectedEquipment =
            element.value ===
            this.haulInformation[this.tripNumber - 1].equipment_type
              ? element
              : {})
      );
    },
    updateEquipmentType() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      info.payload.equipment_type = this.selectedEquipment.value;
      this.$store.dispatch("quotes/haul/updateHaul", info);
      this.$store.commit(
        "quotes/quote/setEquipmentType",
        this.selectedEquipment.label
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/CSS/components/_itemsTable.scss";
::v-deep .table .thead-light th {
  border-radius: 0;
}
::v-deep .el-input__inner {
  background-color: transparent;
  color: white;
}
.calculate-linear-feet {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95%;
}
</style>
